import LayoutTemplatesRotues from './routes'

const LayoutTemplates = () => (
  <LayoutTemplatesRotues />
)

export default LayoutTemplates
